import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { useState } from "react";
import { Row, Col } from "reactstrap";
import AuthProvider from "../Context/AuthContext";
import PrivateRoute from "../Component/PrivateRoute";
import Header from "../Component/Header/Header";
import HeaderMobile from "../Component/Header/HeaderMobile";
import Mixern from "../Container/Mixern";
import TrialRouter from "../Container/TrialRouter";
import FixedCosts from "../Container/FixedCosts";
import SalaryCalculation from "./SalaryCalculation";
import Measures from "./Measures";
import SignUp from "../Container/SignUp";
import Login from "../Container/Login";
import DeleteUser from "../Container/DeleteUser";
import DashboardStandard from "../Component/Dashboard/DashboardStandard";
import DashboardMeasures from "../Component/Dashboard/DashboardMeasures";
import Navlinks from "../Component/Navlinks/Navlinks";
import YearButtons from "../Component/YearButtons/YearButtons";
import CompanyFormButton from "../Component/CompanyFormButton/CompanyFormButton";
import HelpModal from "../Component/HelpModal/HelpModal";
import { useSelector } from "react-redux";
import ErrorMessage from "../Component/Message/ErrorMessage";
import SaveMessage from "../Component/Message/SaveMessage";
import useWindowSize from "../Component/use-window-size";
import NavLinksMobile from "../Component/Navlinks/NavlinksMobile";
import DashboardMeasuresMobile from "../Component/Dashboard/DashboardMeasuresMobile";
import DashboardStandardMobile from "../Component/Dashboard/DashboardStandardMobile";
import CompanyFormButtonMobile from "../Component/CompanyFormButton/CompanyFormButtonMobile";
import YearButtonsMobile from "../Component/YearButtons/YearButtonsMobile";
import Menu from "./../Images/menu.png";
import CloseMenu from "./../Images/closeMenu.png";
import SubscriptionModal from "../Component/HelpModal/SubscriptionModal";
import MobilePending from "../Component/HelpModal/MobilePending";

function App() {
  const currentPage = useSelector((state) => state.activePage);
  const sizeForMobile = useSelector((state) => state.sizeForMobile.size);
  const [helpModalActive, setHelpModalActive] = useState(false);
  const [helpModalContent, setHelpModalContent] = useState("1.0");
  const [menu, setMenu] = useState(true);
  //get current windowsize
  const size = useWindowSize();

  function toggleMenu() {
    setMenu((prevState) => !prevState);
  }
  return (
    <div className="app-container container-fluid">
      {size.width < sizeForMobile ? (
        //Mobile**********************
        <Router>
          <Switch>
            <Route path="/trial" component={TrialRouter} />
            <Route path="*">
              <AuthProvider>
                <MobilePending />
                {helpModalActive === true ? (
                  <HelpModal setHelpModalActive={setHelpModalActive} />
                ) : (
                  ""
                )}
                <SubscriptionModal />
                <div style={{ position: "relative", left: "0", right: "0" }}>
                  <HeaderMobile />
                  <img
                    className="menu-image-mobile"
                    src={menu ? CloseMenu : Menu}
                    alt="Hamburger menu to toggle links and dashboard"
                    onClick={toggleMenu}
                  />
                </div>

                <Row className="max-width-container">
                  <Col xs={40}>
                    <Row>
                      {" "}
                      {/*** Sub Header ***/}
                      {currentPage === "Login" ||
                      currentPage === "Signup" ||
                      currentPage === "deleteUser" ? (
                        ""
                      ) : (
                        <div
                          className={
                            menu === true ? "" : "menu-toggler-mobile-hide"
                          }
                        >
                          <NavLinksMobile />
                        </div>
                      )}
                      {currentPage === "Login" ||
                      currentPage === "Signup" ||
                      currentPage === "deleteUser" ? (
                        ""
                      ) : currentPage === "Åtgärder" ? (
                        <div
                          className={
                            menu === true ? "" : "menu-toggler-mobile-hide"
                          }
                        >
                          <DashboardMeasuresMobile />
                        </div>
                      ) : (
                        <div
                          className={
                            menu === true ? "" : "menu-toggler-mobile-hide"
                          }
                        >
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <YearButtonsMobile />
                            <CompanyFormButtonMobile />
                          </div>
                          <DashboardStandardMobile />
                        </div>
                      )}
                      <ErrorMessage />
                    </Row>
                    <Switch>
                      <PrivateRoute exact path="/" component={Mixern} />
                      <PrivateRoute
                        path="/fastaKostnader"
                        component={FixedCosts}
                      />
                      <PrivateRoute
                        path="/lonekalkyl"
                        component={SalaryCalculation}
                      />
                      <PrivateRoute path="/åtgärder" component={Measures} />
                      <Route path="/signup" component={SignUp} />
                      <Route path="/login" component={Login} />
                    </Switch>
                  </Col>
                </Row>
              </AuthProvider>
            </Route>
          </Switch>
        </Router>
      ) : (
        //Desktop**********************
        //TrialRouter added for all trial routes containing own auth provider
        <Router>
          <Switch>
            <Route path="/trial" component={TrialRouter} /> 
            <Route path="*">
              <AuthProvider>
                {helpModalActive === true ? (
                  <HelpModal
                    setHelpModalActive={setHelpModalActive}
                    helpModalContent={helpModalContent}
                    setHelpModalContent={setHelpModalContent}
                  />
                ) : (
                  ""
                )}
                <SubscriptionModal />
                <Header
                  setHelpModalActive={setHelpModalActive}
                  setHelpModalContent={setHelpModalContent}
                />
                <Row className="max-width-container">
                  <Col xs={40}>
                    <Row>
                      {" "}
                      {/*** Sub Header ***/}
                      {currentPage === "Login" ||
                      currentPage === "Signup" ||
                      currentPage === "deleteUser" ? (
                        ""
                      ) : (
                        <Navlinks />
                      )}
                      {currentPage === "Login" ||
                      currentPage === "Signup" ||
                      currentPage === "deleteUser" ? (
                        ""
                      ) : currentPage === "Åtgärder" ? (
                        <DashboardMeasures />
                      ) : (
                        <>
                          <Col xs={10} className="offset-10">
                            <YearButtons />
                            <CompanyFormButton />
                          </Col>
                          <DashboardStandard />
                        </>
                      )}
                      <ErrorMessage />
                      <SaveMessage />
                    </Row>
                    <Switch>
                      <PrivateRoute exact path="/" component={Mixern} />
                      <PrivateRoute
                        path="/fastaKostnader"
                        component={FixedCosts}
                      />
                      <PrivateRoute
                        path="/lonekalkyl"
                        component={SalaryCalculation}
                      />
                      <PrivateRoute path="/åtgärder" component={Measures} />
                      <Route path="/signup" component={SignUp} />
                      <Route path="/login" component={Login} />
                      <Route path="/deleteUser" component={DeleteUser} />
                    </Switch>
                  </Col>
                </Row>
              </AuthProvider>
            </Route>
          </Switch>
        </Router>
      )}
    </div>
  );
}
export default App;
